import React from 'react';
import {
  EXIT_DELAY_WARN_MINUTES,
  EXIT_EARLY_WARN_MINUTES,
  formatMinutesHuman,
  getExitDeltaMinutesFromShiftEnd,
  getExitEarlyMinutesBeforeShiftEnd,
} from '../utils/attendanceBoardAlerts';

/**
 * Icono ! (ámbar) con detalle al clic. Cierra al volver a clic o al abrir otro con misma callback global.
 */
export function AttendanceBoardTimeAlerts({
  row,
  boardDateYmd,
  openKey,
  setOpenKey,
  rowKey,
  showEntry = true,
  showExit = true,
}) {
  const exitDelta = showExit && boardDateYmd ? getExitDeltaMinutesFromShiftEnd(row, boardDateYmd) : null;
  const exitEarlyMins = showExit && boardDateYmd ? getExitEarlyMinutesBeforeShiftEnd(row, boardDateYmd) : null;
  const showExitLateWarn = exitDelta !== null && exitDelta >= EXIT_DELAY_WARN_MINUTES;
  const showExitEarlyWarn = exitEarlyMins !== null && exitEarlyMins >= EXIT_EARLY_WARN_MINUTES;
  const showEntryWarn = showEntry && row.is_late && Number(row.late_minutes) > 0;

  const kIn = `${rowKey}:in`;
  const kOutLate = `${rowKey}:out-late`;
  const kOutEarly = `${rowKey}:out-early`;

  const btnClass =
    'inline-flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full border border-amber-300/90 bg-amber-50 text-amber-700 text-sm font-bold leading-none shadow-sm hover:bg-amber-100 active:scale-95 touch-feedback';

  const btnEarlyClass =
    'inline-flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full border border-sky-300/90 bg-sky-50 text-sky-800 text-sm font-bold leading-none shadow-sm hover:bg-sky-100 active:scale-95 touch-feedback';

  return (
    <span className="inline-flex flex-wrap items-center gap-1 align-middle">
      {showEntryWarn && (
        <span className="relative inline-flex items-center">
          <button
            type="button"
            className={btnClass}
            aria-expanded={openKey === kIn}
            aria-label="Ver detalle de entrada tarde"
            onClick={(e) => {
              e.stopPropagation();
              setOpenKey(openKey === kIn ? null : kIn);
            }}
          >
            !
          </button>
          {openKey === kIn && (
            <span
              role="tooltip"
              className="absolute left-0 top-full z-20 mt-1 w-[min(18rem,calc(100vw-2rem))] rounded-lg border border-amber-200 bg-amber-50 px-2.5 py-2 text-xs font-normal text-amber-950 shadow-md"
            >
              Entrada tarde: <strong>{row.late_minutes} min</strong> después del fin de la tolerancia (inicio del
              turno + margen).
            </span>
          )}
        </span>
      )}
      {showExitEarlyWarn && (
        <span className="relative inline-flex items-center">
          <button
            type="button"
            className={btnEarlyClass}
            aria-expanded={openKey === kOutEarly}
            aria-label="Ver detalle de salida anticipada"
            onClick={(e) => {
              e.stopPropagation();
              setOpenKey(openKey === kOutEarly ? null : kOutEarly);
            }}
          >
            !
          </button>
          {openKey === kOutEarly && (
            <span
              role="tooltip"
              className="absolute left-0 top-full z-20 mt-1 w-[min(18rem,calc(100vw-2rem))] rounded-lg border border-sky-200 bg-sky-50 px-2.5 py-2 text-xs font-normal text-sky-950 shadow-md"
            >
              Salida anticipada: <strong>{formatMinutesHuman(exitEarlyMins)}</strong> antes del horario de fin del
              turno (<span className="tabular-nums">{row.shift_end}</span>).
            </span>
          )}
        </span>
      )}
      {showExitLateWarn && (
        <span className="relative inline-flex items-center">
          <button
            type="button"
            className={btnClass}
            aria-expanded={openKey === kOutLate}
            aria-label="Ver detalle de salida después del fin del turno"
            onClick={(e) => {
              e.stopPropagation();
              setOpenKey(openKey === kOutLate ? null : kOutLate);
            }}
          >
            !
          </button>
          {openKey === kOutLate && (
            <span
              role="tooltip"
              className="absolute left-0 top-full z-20 mt-1 w-[min(18rem,calc(100vw-2rem))] rounded-lg border border-amber-200 bg-amber-50 px-2.5 py-2 text-xs font-normal text-amber-950 shadow-md"
            >
              Salida <strong>{formatMinutesHuman(exitDelta)}</strong> después del horario nominal de fin del turno (
              <span className="tabular-nums">{row.shift_end}</span>).
            </span>
          )}
        </span>
      )}
    </span>
  );
}
